export function normalizeEmail(email?: string) {
  return email?.trim().toLowerCase() ?? ''
}
